module.exports = {
  footerText: 'Copyright Loanpalz Inc.© 2020-2021',
};
